(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('app-story')) {
    customElements.define('app-story', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.frame = null;
        this.intro = this.querySelector('.app-story__intro');
        this.items = Array.from(this.querySelectorAll('.app-story__item'));
        this.media = Array.from(this.querySelectorAll('.app-story__media'));
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.desktop = matchMedia('(min-width: 769px)');
        window.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
        window.addEventListener('resize', () => this.schedule(true), options);
        this.desktop.addEventListener('change', () => this.schedule(true), options);
        this.addEventListener('load', () => this.schedule(true), { ...options, capture: true });
        this.addEventListener('focusin', (event) => {
          this.revealGroup(event.target.closest('.app-story__item, .app-story__intro'), false);
          this.schedule();
        }, options);
        this.addEventListener('focusout', () => this.schedule(), options);
        this.addEventListener('shopify:block:select', (event) => {
          this.selectedItem = event.target.closest('.app-story__item');
          this.revealGroup(this.selectedItem, false);
          this.schedule(true);
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.selectedItem = null;
          this.schedule();
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.schedule(true));
        this.resizeObserver.observe(this);
        if (this.intro) this.resizeObserver.observe(this.intro);
        this.items.forEach((item) => this.resizeObserver.observe(item));
        this.media.forEach((media) => {
          this.resizeObserver.observe(media);
          const image = media.querySelector('img');
          if (image) this.resizeObserver.observe(image);
        });
        this.measure();
        this.updateActive();
        this.classList.add('is-ready');
        this.initializeReveals(options);
      }

      initializeReveals(options) {
        if (!this.closest('.lp365-page') || this.dataset.designMode === 'true') return;
        if (!window.IntersectionObserver || !Element.prototype.animate) return;
        this.revealMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.revealedGroups = this.revealedGroups || new WeakSet();
        this.revealAnimations = new Map();
        const groups = [this.intro, ...this.items].filter(Boolean);
        this.revealMotion.addEventListener('change', () => {
          if (this.revealMotion.matches) groups.forEach((group) => this.revealGroup(group, false));
        }, options);
        if (this.revealMotion.matches) {
          groups.forEach((group) => this.revealedGroups.add(group));
          return;
        }
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.revealGroup(entry.target);
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
        groups.forEach((group) => {
          if (group.getBoundingClientRect().bottom <= 0 || group.contains(document.activeElement)) {
            this.revealedGroups.add(group);
          }
          if (!this.revealedGroups.has(group)) this.revealObserver.observe(group);
        });
      }

      revealGroup(group, animate = true) {
        if (!group || !this.revealedGroups) return;
        this.revealObserver?.unobserve(group);
        if (!animate) {
          this.revealedGroups.add(group);
          this.revealAnimations?.forEach((owner, animation) => {
            if (owner === group) animation.cancel();
          });
          return;
        }
        if (this.revealedGroups.has(group)) return;
        this.revealedGroups.add(group);
        if (this.revealMotion.matches) return;
        Array.from(group.children).forEach((element) => {
          const animation = element.animate([
            { opacity: 0, transform: 'translateY(28px)' },
            { opacity: 1, transform: 'none' }
          ], { duration: 1050, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' });
          this.revealAnimations.set(animation, group);
          animation.onfinish = animation.oncancel = () => this.revealAnimations.delete(animation);
        });
      }

      schedule(measure = false) {
        if (!this.isConnected || !this.controller) return;
        this.needsMeasure = this.needsMeasure || measure;
        if (this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.needsMeasure) this.measure();
          this.needsMeasure = false;
          this.updateActive();
        });
      }

      measure() {
        if (this.intro) {
          const height = this.intro.getBoundingClientRect().height;
          const top = parseFloat(getComputedStyle(this).getPropertyValue('--app-story-sticky-top')) || 0;
          this.style.setProperty('--app-story-intro-height', `${height}px`);
          this.classList.toggle('is-intro-tall', this.desktop.matches && height > window.innerHeight - top - 24);
        }
        this.media.forEach((media) => {
          const image = media.querySelector('img');
          const cropped = !this.desktop.matches && image && image.getBoundingClientRect().height > media.clientHeight + 1;
          media.classList.toggle('is-cropped', Boolean(cropped));
        });
      }

      updateActive() {
        if (!this.desktop.matches) {
          this.items.forEach((item) => item.classList.remove('is-active'));
          return;
        }
        const focusedItem = this.contains(document.activeElement)
          ? document.activeElement.closest('.app-story__item')
          : null;
        let active = this.selectedItem || focusedItem;
        if (!active) {
          const center = window.innerHeight / 2;
          let distance = Infinity;
          this.items.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const nextDistance = Math.abs(rect.top + rect.height / 2 - center);
            if (nextDistance < distance) {
              distance = nextDistance;
              active = item;
            }
          });
        }
        this.items.forEach((item) => item.classList.toggle('is-active', item === active));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        this.revealObserver = null;
        this.revealAnimations?.forEach((owner, animation) => animation.cancel());
        this.revealAnimations?.clear();
        this.selectedItem = null;
        this.needsMeasure = false;
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-promo')) {
    customElements.define('bundle-promo', class extends HTMLElement {
      connectedCallback() {
        this.start = this.start || this.init.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        if (this.dataset.animate === 'false' || this.dataset.revealed === 'true') return;
        if (!window.gsap || !window.ScrollTrigger) return;
        this.card = this.querySelector('.bundle-promo__card');
        if (!this.card || this.card.getBoundingClientRect().bottom <= 0) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.showAll = () => {
          this.context?.revert();
          this.context = null;
          this.dataset.revealed = 'true';
        };
        this.onMotionChange = () => {
          if (this.motion.matches) this.showAll();
        };
        this.onFocus = () => this.showAll();
        this.onSelect = () => this.showAll();
        this.editorSection = this.closest('.shopify-section');
        this.motion.addEventListener('change', this.onMotionChange);
        this.addEventListener('focusin', this.onFocus);
        this.editorSection?.addEventListener('shopify:section:select', this.onSelect);
        if (this.motion.matches) {
          this.showAll();
          return;
        }

        gsap.registerPlugin(ScrollTrigger);
        const items = Array.from(this.querySelectorAll('[data-bundle-reveal]'));
        const mobile = window.matchMedia('(max-width: 768px)').matches;
        this.context = gsap.context(() => {
          this.timeline = gsap.timeline({
            defaults: { ease: 'power2.out' },
            scrollTrigger: { trigger: this.card.parentElement, start: 'top 85%', once: true },
            onComplete: () => { this.dataset.revealed = 'true'; }
          });
          this.timeline
            .from(this.card, { opacity: 0, y: mobile ? 32 : 48, duration: 1.05, clearProps: 'opacity,transform' });
          if (items.length) {
            this.timeline.from(items, {
              opacity: 0,
              y: mobile ? 16 : 24,
              duration: 1.05,
              stagger: 0.15,
              clearProps: 'opacity,transform'
            }, 0.18);
          }
        }, this);
        this.onImageLoad = () => {
          if (this.isConnected && this.context) ScrollTrigger.refresh();
        };
        this.images = Array.from(this.querySelectorAll('img'));
        this.images.forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.onImageLoad, { once: true });
        });
        document.fonts?.ready.then(this.onImageLoad);
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.context?.revert();
        this.context = null;
        this.timeline = null;
        this.motion?.removeEventListener('change', this.onMotionChange);
        this.removeEventListener('focusin', this.onFocus);
        this.editorSection?.removeEventListener('shopify:section:select', this.onSelect);
        this.images?.forEach((image) => image.removeEventListener('load', this.onImageLoad));
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tab-build-custom-roll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tab-roll')) {
    customElements.define('collection-tab-roll', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-tab]');
          if (this.tabs.includes(tab)) this.selectTab(tab.dataset.tab);
        }, options);
        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-tab]');
          const index = this.tabs.indexOf(tab);
          if (index < 0) return;
          let nextIndex;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          const nextTab = this.tabs[(nextIndex + this.tabs.length) % this.tabs.length];
          nextTab.focus();
          this.selectTab(nextTab.dataset.tab);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          this.selectTab(event.detail.blockId);
        }, options);
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.refreshCarousel());
        this.observer.observe(this);
        this.refreshCarousel();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
      }

      selectTab(blockId) {
        if (!this.tabs.some((tab) => tab.dataset.tab === blockId)) return;
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.tab === blockId;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== blockId;
        });
        this.refreshCarousel();
      }

      refreshCarousel() {
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const panel = this.panels.find((item) => !item.hidden);
          const carousel = panel?.querySelector('carousel-slider');
          if (!carousel?.slider || carousel.slides.length < 2) return;
          carousel.handleBreakpointChange();
          if (carousel.progress) carousel.updateProgress();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-easy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('header-easy')) {
    class HeaderEasy extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.desktopQuery = window.matchMedia('(min-width: 769px)');
        this.desktop = this.querySelector('.header-easy__desktop');
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('.header-easy__open');
        this.closeButton = this.querySelector('.header-easy__close');
        this.shade = this.querySelector('.header-easy__shade');
        this.wrapper = this.closest('.header-easy-section');
        this.root = document.documentElement;
        this.hideOnScroll = this.dataset.hideOnScroll === 'true';
        this.headerTransitionSpeed = 300;
        this.stickyTransitioning = false;
        this.lastScrollPos = window.scrollY;
        this.keyboardNavigation = false;
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') this.keyboardNavigation = true;
        }, options);
        document.addEventListener('pointerdown', () => { this.keyboardNavigation = false; }, options);
        if (this.hideOnScroll) {
          this.savedRootStyles = ['--header-height', '--sticky-header-height'].map((name) => [
            name,
            this.root.style.getPropertyValue(name),
            this.root.style.getPropertyPriority(name),
          ]);
          this.savedScrollClasses = ['scrolling-up', 'scrolling-down'].map((name) => [
            name, this.root.classList.contains(name),
          ]);
          this.setHeaderHidden(false);
        }
        this.addEventListener('focusin', () => this.setHeaderHidden(false), options);
        this.items = [...this.querySelectorAll('.header-easy__item--parent')];
        this.items.forEach((item, index) => {
          const toggle = item.querySelector('.header-easy__submenu-toggle');
          const panel = item.querySelector('.header-easy__submenu');
          panel.id = `HeaderEasySubmenu-${this.dataset.sectionId}-${index}`;
          toggle.setAttribute('aria-controls', panel.id);
          toggle.addEventListener('click', () => this.toggleItem(item, !item.classList.contains('is-open')), options);
          if (this.desktop.contains(item)) {
            item.addEventListener(
              'pointerenter',
              (event) => {
                if (event.pointerType === 'mouse') this.toggleItem(item, true);
              },
              options
            );
            item.addEventListener(
              'pointerleave',
              (event) => {
                if (event.pointerType === 'mouse' && !item.contains(document.activeElement))
                  this.toggleItem(item, false);
              },
              options
            );
            item.addEventListener(
              'focusout',
              (event) => {
                if (!item.contains(event.relatedTarget)) this.toggleItem(item, false);
              },
              options
            );
          }
        });
        this.openButton.addEventListener('click', () => this.openMobile(), options);
        this.closeButton.addEventListener('click', () => this.closeMobile(), options);
        this.dialog.addEventListener(
          'cancel',
          (event) => {
            event.preventDefault();
            this.closeMobile();
          },
          options
        );
        this.dialog.addEventListener(
          'close',
          () => {
            if (!this.dialog.open) this.restorePage();
          },
          options
        );
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('a[href]')) this.closeMobile(false, true);
          },
          options
        );
        this.dialog.addEventListener(
          'transitionend',
          (event) => {
            if (event.target === this.dialog && event.propertyName === 'opacity' && this.closing)
              this.finishCloseMobile();
          },
          options
        );
        this.shade.addEventListener('click', () => this.closeItems(), options);
        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape' || this.dialog.open) return;
            const item = this.desktop.querySelector('.is-open');
            if (item) {
              event.preventDefault();
              this.closeItems();
              item.querySelector('button').focus();
            }
          },
          options
        );
        document.addEventListener(
          'click',
          (event) => {
            if (!this.contains(event.target)) this.closeItems();
          },
          options
        );
        this.desktopQuery.addEventListener(
          'change',
          () => {
            this.closeMobile(false, true);
            this.closeItems();
            this.updateGeometry();
          },
          options
        );
        window.addEventListener(
          'scroll',
          () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.handleScroll();
              if (!this.shade.hidden) this.updateGeometry();
            });
          },
          { ...options, passive: true }
        );
        window.addEventListener('resize', () => this.updateGeometry(), options);
        window.addEventListener('pagehide', () => this.closeMobile(false, true), options);
        document.addEventListener(
          'shopify:section:unload',
          (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.closeMobile(false, true);
          },
          options
        );
        this.resizeObserver = new ResizeObserver(() => this.updateGeometry());
        this.resizeObserver.observe(this);
        this.updateGeometry();
      }

      handleScroll() {
        if (!this.hideOnScroll) return;
        const scrollTop = Math.max(0, Math.min(window.scrollY, this.root.scrollHeight - window.innerHeight));
        if (this.savedBody || this.dialog.open || document.body.classList.contains('fixed') ||
            getComputedStyle(document.body).position === 'fixed') {
          this.lastScrollPos = scrollTop;
          return;
        }
        if (!this.shade.hidden || (this.keyboardNavigation && this.contains(document.activeElement))) {
          this.setHeaderHidden(false);
          this.lastScrollPos = scrollTop;
          return;
        }
        if (scrollTop < 100) {
          this.setHeaderHidden(false);
        } else {
          if (this.stickyTransitioning) return;
          if (scrollTop > this.lastScrollPos + 15) this.setHeaderHidden(true);
          else if (scrollTop < this.lastScrollPos - 5) this.setHeaderHidden(false);
          else return;
        }
        this.lastScrollPos = scrollTop;
      }

      setHeaderHidden(hidden) {
        if (!this.hideOnScroll) return;
        const changed = this.wrapper.classList.contains('is-out') !== hidden;
        this.wrapper.classList.toggle('is-out', hidden);
        this.root.classList.toggle('scrolling-down', hidden);
        this.root.classList.toggle('scrolling-up', !hidden);
        if (!changed) return;
        clearTimeout(this.headerTimer);
        this.stickyTransitioning = true;
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : this.headerTransitionSpeed;
        this.headerTimer = setTimeout(() => {
          this.stickyTransitioning = false;
          this.handleScroll();
        }, duration);
      }

      toggleItem(item, open) {
        if (open) {
          this.items.forEach((other) => {
            if (other !== item) this.setItem(other, false);
          });
        }
        this.setItem(item, open);
        this.shade.hidden = !this.desktop.querySelector('.is-open');
        this.wrapper.classList.toggle('is-menu-open', !this.shade.hidden || this.dialog.open);
        if (open) this.setHeaderHidden(false);
        this.updateGeometry();
      }

      setItem(item, open) {
        item.classList.toggle('is-open', open);
        item.querySelector('.header-easy__submenu-toggle').setAttribute('aria-expanded', String(open));
        item.querySelector('.header-easy__submenu').hidden = !open;
      }

      closeItems() {
        this.items.forEach((item) => this.setItem(item, false));
        this.shade.hidden = true;
        this.wrapper.classList.toggle('is-menu-open', this.dialog.open);
      }

      updateGeometry() {
        if (this.hideOnScroll) {
          const height = `${this.offsetHeight}px`;
          this.root.style.setProperty('--header-height', height);
          this.root.style.setProperty('--sticky-header-height', height);
        }
        if (this.placeholder) this.placeholder.style.height = `${this.wrapper.getBoundingClientRect().height}px`;
        this.style.setProperty('--easy-bottom', `${Math.max(0, this.getBoundingClientRect().bottom)}px`);
        const brandBottom = this.querySelector('.header-easy__brand').getBoundingClientRect().bottom;
        this.style.setProperty('--easy-mobile-top', `${Math.max(0, brandBottom)}px`);
        this.desktop.querySelectorAll('.is-open .header-easy__submenu').forEach((panel) => {
          panel.style.removeProperty('--easy-submenu-shift');
          const rect = panel.getBoundingClientRect();
          const shift = Math.max(16 - rect.left, Math.min(0, document.documentElement.clientWidth - 16 - rect.right));
          panel.style.setProperty('--easy-submenu-shift', `${shift}px`);
        });
      }

      openMobile() {
        if (this.desktopQuery.matches) return;
        if (this.dialog.open) {
          clearTimeout(this.closeTimer);
          this.closing = false;
          this.dialog.classList.add('is-open');
          return;
        }
        this.closeItems();
        this.wrapper.classList.add('is-menu-open');
        this.setHeaderHidden(false);
        this.savedScroll = { x: window.scrollX, y: window.scrollY };
        this.wrapper = this.closest('.header-easy-section');
        const wrapperRect = this.wrapper.getBoundingClientRect();
        const wrapperStyle = getComputedStyle(this.wrapper);
        this.placeholder = document.createElement('div');
        this.placeholder.setAttribute('aria-hidden', 'true');
        this.placeholder.style.height = `${wrapperRect.height}px`;
        this.placeholder.style.marginBlockStart = wrapperStyle.marginBlockStart;
        this.placeholder.style.marginBlockEnd = wrapperStyle.marginBlockEnd;
        this.placeholder.style.flexShrink = '0';
        this.wrapper.before(this.placeholder);
        this.savedWrapper = ['position', 'top', 'left', 'width'].map((name) => [
          name,
          this.wrapper.style.getPropertyValue(name),
          this.wrapper.style.getPropertyPriority(name),
        ]);
        this.wrapper.style.setProperty('position', 'fixed');
        this.wrapper.style.setProperty('top', `${wrapperRect.top}px`);
        this.wrapper.style.setProperty('left', `${wrapperRect.left}px`);
        this.wrapper.style.setProperty('width', '100%');
        const properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
        this.savedBody = properties.map((name) => [
          name,
          document.body.style.getPropertyValue(name),
          document.body.style.getPropertyPriority(name),
        ]);
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.setProperty('position', 'fixed');
        document.body.style.setProperty('top', `${-this.savedScroll.y}px`);
        document.body.style.setProperty('left', `${-this.savedScroll.x}px`);
        document.body.style.setProperty('width', '100%');
        document.body.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('padding-right', `${padding + scrollbar}px`);
        this.updateGeometry();
        this.dialog.showModal();
        this.querySelector('.header-easy__dialog-content').scrollTop = 0;
        this.openButton.setAttribute('aria-expanded', 'true');
        this.closeButton.focus({ preventScroll: true });
        this.dialog.getBoundingClientRect();
        this.openFrame = requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      }

      closeMobile(restoreFocus = true, immediate = false) {
        if (!this.dialog) return;
        cancelAnimationFrame(this.openFrame);
        clearTimeout(this.closeTimer);
        this.restoreFocus = restoreFocus;
        this.closing = true;
        this.dialog.classList.remove('is-open');
        if (immediate || !this.dialog.open || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finishCloseMobile();
        } else {
          this.closeTimer = setTimeout(() => this.finishCloseMobile(), 350);
        }
      }

      finishCloseMobile() {
        clearTimeout(this.closeTimer);
        this.closing = false;
        const wasOpen = this.dialog.open;
        if (wasOpen) this.dialog.close();
        this.restorePage();
        if (wasOpen && this.restoreFocus && !this.desktopQuery.matches) this.openButton.focus({ preventScroll: true });
      }

      restorePage() {
        cancelAnimationFrame(this.openFrame);
        clearTimeout(this.closeTimer);
        this.closing = false;
        this.dialog.classList.remove('is-open');
        this.openButton.setAttribute('aria-expanded', 'false');
        if (!this.savedBody) return;
        this.savedWrapper.forEach(([name, value, priority]) => {
          if (value) this.wrapper.style.setProperty(name, value, priority);
          else this.wrapper.style.removeProperty(name);
        });
        this.savedWrapper = null;
        this.placeholder?.remove();
        this.placeholder = null;
        this.savedBody.forEach(([name, value, priority]) => {
          if (value) document.body.style.setProperty(name, value, priority);
          else document.body.style.removeProperty(name);
        });
        this.savedBody = null;
        this.lastScrollPos = this.savedScroll.y;
        window.scrollTo({ left: this.savedScroll.x, top: this.savedScroll.y, behavior: 'instant' });
        this.closeItems();
      }

      disconnectedCallback() {
        this.closeMobile(false, true);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.headerTimer);
        this.scrollFrame = null;
        this.wrapper.classList.remove('is-out', 'is-menu-open');
        this.savedRootStyles?.forEach(([name, value, priority]) => {
          if (value) this.root.style.setProperty(name, value, priority);
          else this.root.style.removeProperty(name);
        });
        this.savedScrollClasses?.forEach(([name, present]) => this.root.classList.toggle(name, present));
        this.controller = null;
      }
    }
    customElements.define('header-easy', HeaderEasy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.panel.classList.contains('header-sidebar-banner-panel')) {
          if (!this.hasTransition) {
            this.toggle.addEventListener('click', this.handleToggle.bind(this));
            this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
          }
          this.toggle.addEventListener('focusin', () => {
            if (window.matchMedia(theme.mediaQueries.md).matches) {
              MainMenu.handleSidenavMenuToggle(null, this.toggle);
            }
          });
        }

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      connectedCallback() {
        const banner = this.panel.querySelector('.header-sidebar-banner');
        if (!banner) return;

        this.bannerResizeObserver = new ResizeObserver(() => {
          if (window.matchMedia(theme.mediaQueries.md).matches
            && this.toggle.classList.contains('is-visible') && banner.clientWidth) {
            MainMenu.handleSidenavMenuToggle(null, this.toggle);
          }
        });
        this.bannerResizeObserver.observe(banner);
      }

      disconnectedCallback() {
        this.bannerResizeObserver?.disconnect();
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (!isLargeScreen && this.toggle.matches('.js-toggle')) {
          const menu = this.closest('main-menu');
          const index = menu?.mobileDisclosures?.indexOf(this.disclosure);
          this.disclosure.open = menu?.mobileHistoryPath?.includes(index) || false;
        } else if (!isLargeScreen) {
          this.disclosure.open = this.closest('main-menu')?.getMobileAccordionState?.(this.disclosure) ?? false;
        } else {
          this.disclosure.open = isLargeScreen;
        }
        if (isLargeScreen && !this.panel.classList.contains('header-sidebar-banner-panel')) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (isLargeScreen && this.panel.classList.contains('header-sidebar-banner-panel')) {
          if (!e.target.closest('a[href]')) e.preventDefault();
          MainMenu.handleSidenavMenuToggle(null, this.toggle);
          return;
        }
        // Full-page mobile panels are controlled by MainMenu; only accordions animate their height here.
        if (!isLargeScreen && this.toggle.matches('.js-toggle')) return;
        if (!(this.matches('.js-mega-nav') && isLargeScreen)) {
          super.handleToggle(e);
          if (!isLargeScreen) this.closest('main-menu')?.saveMobileAccordionState?.();
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp365-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp365-comparison')) {
    customElements.define(
      'lp365-comparison',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const { signal } = this.controller;
          const panels = Array.from(this.querySelectorAll('[data-comparison-reveal]'));
          const heading = this.querySelector('[data-comparison-reveal="heading"]');
          const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const showAll = () => {
            this.observer?.disconnect();
            this.classList.remove('is-ready');
            panels.forEach((panel) => panel.classList.add('is-visible'));
          };
          if (
            this.dataset.animate !== 'true' ||
            this.dataset.designMode === 'true' ||
            motion.matches ||
            !('IntersectionObserver' in window)
          ) {
            showAll();
            return;
          }
          let headingStarted = -Infinity;
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const panel = entry.target;
                if (heading && !heading.classList.contains('is-visible')) {
                  headingStarted = performance.now();
                  heading.classList.add('is-visible');
                  this.observer.unobserve(heading);
                }
                if (panel !== heading) {
                  panel.style.setProperty(
                    '--lc-reveal-delay',
                    `${Math.max(0, 200 - (performance.now() - headingStarted))}ms`
                  );
                }
                panel.classList.add('is-visible');
                this.observer.unobserve(panel);
              });
            },
            { threshold: 0, rootMargin: '0px 0px -32px 0px' }
          );
          this.classList.add('is-ready');
          panels.forEach((panel) => {
            if (!panel.classList.contains('is-visible')) this.observer.observe(panel);
          });
          this.addEventListener('focusin', showAll, { signal });
          motion.addEventListener(
            'change',
            (event) => {
              if (event.matches) showAll();
            },
            { signal }
          );
        }
        disconnectedCallback() {
          this.observer?.disconnect();
          this.controller?.abort();
          this.classList.remove('is-ready');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpg365-protection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lpg365-protection')) {
    customElements.define('lpg365-protection', class extends HTMLElement {
      connectedCallback() {
        this.start = this.start || this.init.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        if (this.dataset.animate === 'false' || !window.gsap || !window.ScrollTrigger) return;

        this.rows = Array.from(this.querySelectorAll('[data-protection-reveal]'));
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.showAll = () => {
          this.context?.revert();
          this.context = null;
          this.rows.forEach((row) => { row.dataset.revealed = 'true'; });
        };
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.showAll();
        }, { signal });
        this.addEventListener('focusin', this.showAll, { signal });
        this.addEventListener('shopify:block:select', this.showAll, { signal });
        const sectionWrapper = this.closest('.shopify-section') || this;
        sectionWrapper.addEventListener('shopify:section:select', this.showAll, { signal });

        if (this.motion.matches) {
          this.showAll();
          return;
        }

        const pending = this.rows.filter((row) => {
          if (row.getBoundingClientRect().bottom <= 0) row.dataset.revealed = 'true';
          return row.dataset.revealed !== 'true';
        });
        if (!pending.length) return;

        try {
          gsap.registerPlugin(ScrollTrigger);
          this.context = gsap.context(() => {
            gsap.set(pending, {
              opacity: 0,
              y: window.matchMedia('(max-width: 768px)').matches ? 32 : 48
            });
            ScrollTrigger.batch(pending, {
              start: 'top 88%',
              once: true,
              interval: 0.12,
              onEnter: (rows) => {
                if (!this.context || signal.aborted) return;
                rows.forEach((row) => { row.dataset.revealed = 'true'; });
                this.context.add(() => {
                  gsap.to(rows, {
                    opacity: 1,
                    y: 0,
                    duration: 1.05,
                    stagger: 0.15,
                    ease: 'power2.out',
                    overwrite: true,
                    clearProps: 'opacity,transform'
                  });
                });
              }
            });
          }, this);
        } catch {
          this.showAll();
          return;
        }

        const refresh = () => {
          if (signal.aborted || !this.context || this.refreshFrame) return;
          this.refreshFrame = requestAnimationFrame(() => {
            this.refreshFrame = null;
            if (this.isConnected && this.context) ScrollTrigger.refresh();
          });
        };
        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', refresh, { once: true, signal });
        });
        document.fonts?.ready.then(refresh);
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.controller?.abort();
        if (this.refreshFrame) cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = null;
        this.context?.revert();
        this.context = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-text-reveal')) {
    customElements.define('media-text-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        const reveal = () => {
          this.revealObserver?.disconnect();
          this.classList.remove('is-animated');
        };
        if (this.dataset.animate === 'true' && !this.motion.matches && this.dataset.designMode !== 'true' && 'IntersectionObserver' in window) {
          this.revealObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.revealObserver.unobserve(entry.target);
            });
          }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
          this.classList.add('is-animated');
          this.querySelectorAll('[data-reveal]').forEach(element => this.revealObserver.observe(element));
          this.addEventListener('focusin', reveal, { signal });
        }
        this.video = this.querySelector('video');
        this.button = this.querySelector('.media-text-reveal__play');
        this.playbackButton = this.querySelector('.media-text-reveal__playback');
        this.error = this.querySelector('.media-text-reveal__error');
        this.motion.addEventListener('change', () => {
          reveal();
          this.syncPlayback();
        }, { signal });
        if (!this.video || !this.button) return;
        this.inView = false;
        this.userPaused = false;
        this.button.hidden = false;
        this.playbackButton?.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.attemptPlay(true);
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, { signal });
        this.button.addEventListener('click', () => {
          this.userPaused = false;
          this.attemptPlay(true);
        }, { signal });
        this.video.addEventListener('playing', () => {
          if (!this.inView || document.hidden) {
            this.video.pause();
            return;
          }
          const hadFocus = document.activeElement === this.button;
          this.button.hidden = true;
          this.error.hidden = true;
          this.updatePlaybackButton();
          if (hadFocus) (this.playbackButton || this.video).focus();
        }, { signal });
        this.video.addEventListener('pause', () => {
          if (this.inView && !document.hidden) this.userPaused = true;
          this.updatePlaybackButton();
        }, { signal });
        this.video.addEventListener('error', () => {
          this.button.hidden = false;
          this.error.hidden = false;
          this.updatePlaybackButton();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.syncPlayback();
          });
          this.videoObserver.observe(this.querySelector('.media-text-reveal__media'));
        } else {
          this.inView = true;
        }
      }
      attemptPlay(manual = false) {
        if (!this.video || this.pendingPlay) return;
        this.error.hidden = true;
        if (manual && this.video.error) this.video.load();
        this.pendingPlay = true;
        this.video.play()?.catch(error => {
          if (!this.isConnected || error.name === 'AbortError') return;
          this.button.hidden = false;
          if (error.name !== 'NotAllowedError') this.error.hidden = false;
        }).finally(() => { this.pendingPlay = false; });
      }
      updatePlaybackButton() {
        if (!this.playbackButton) return;
        this.playbackButton.hidden = !this.button.hidden;
        this.playbackButton.classList.toggle('is-paused', this.video.paused);
        this.playbackButton.setAttribute('aria-label', this.video.paused ? this.playbackButton.dataset.playLabel : this.playbackButton.dataset.pauseLabel);
      }
      syncPlayback() {
        if (!this.video) return;
        if (!this.inView || document.hidden) {
          this.video.pause();
        } else if (this.dataset.autoplay === 'true' && !this.motion.matches && !this.userPaused && !this.video.error) {
          this.attemptPlay();
        } else if (this.motion.matches && this.dataset.autoplay === 'true') {
          this.video.pause();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.revealObserver?.disconnect();
        this.videoObserver?.disconnect();
        this.video?.pause();
        this.classList.remove('is-animated');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-reveal')) {
    customElements.define('product-reveal', class extends HTMLElement {
      connectedCallback() {
        this.start = this.start || this.init.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.rows = Array.from(this.querySelectorAll('[data-reveal-row]'));
        if (!window.gsap || !window.ScrollTrigger) return;

        gsap.registerPlugin(ScrollTrigger);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.showAll = () => {
          this.context?.revert();
          this.context = null;
          this.rows.forEach((row) => { row.dataset.revealed = 'true'; });
        };
        this.onMotionChange = () => {
          if (this.motion.matches) this.showAll();
        };
        this.onFocus = () => this.showAll();
        this.onBlockSelect = () => this.showAll();
        this.motion.addEventListener('change', this.onMotionChange);
        this.addEventListener('focusin', this.onFocus);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.motion.matches) {
          this.showAll();
          return;
        }

        const pending = this.rows.filter((row) => {
          if (row.getBoundingClientRect().bottom <= 0) row.dataset.revealed = 'true';
          return row.dataset.revealed !== 'true';
        });
        this.context = gsap.context(() => {
          gsap.set(pending, { opacity: 0, y: 28 });
          ScrollTrigger.batch(pending, {
            start: 'top 90%',
            once: true,
            interval: 0.08,
            onEnter: (rows) => {
              if (!this.context) return;
              rows.forEach((row) => { row.dataset.revealed = 'true'; });
              this.context.add(() => {
                gsap.to(rows, {
                  opacity: 1,
                  y: 0,
                  duration: this.closest('.lp365-page') ? 1 : 0.65,
                  stagger: 0.12,
                  ease: 'power2.out',
                  overwrite: true,
                  clearProps: 'opacity,transform'
                });
              });
            }
          });
        }, this);

        document.fonts?.ready.then(() => {
          if (this.isConnected && this.context) ScrollTrigger.refresh();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.context?.revert();
        this.context = null;
        this.motion?.removeEventListener('change', this.onMotionChange);
        this.removeEventListener('focusin', this.onFocus);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-video-hero')) {
    class ScrollVideoHero extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        const start = () => {
          if (!this.isConnected || this.started) return;
          this.started = true;
          this.panels = Array.from(this.querySelectorAll('[data-stage]'));
          this.videos = this.panels.map(panel => panel.querySelector('video'));
          this.mediaLayers = this.panels.map(panel => panel.querySelector('.scroll-video-hero__media'));
          this.helpers = this.panels.map(panel => panel.querySelector('.scroll-video-hero__scroll-helper'));
          this.viewport = this.querySelector('.scroll-video-hero__viewport');
          this.measure = this.querySelector('.scroll-video-hero__measure');
          this.button = this.querySelector('[data-playback]');
          this.mobile = window.matchMedia('(max-width: 768px)');
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.userPaused = false;
          this.activeIndex = -1;
          this.editorIndex = null;
          this.nearby = false;
          this.visible = false;
          this.button.addEventListener('click', () => {
            this.userPaused = !this.videos[this.activeIndex]?.paused;
            this.syncVideo();
          }, { signal });
          this.videos.forEach(video => {
            if (!video) return;
            ['loadeddata', 'canplay', 'playing'].forEach(name => {
              video.addEventListener(name, () => {
                if (video.readyState >= 2) video.classList.add('is-ready');
                this.updateMedia();
              }, { signal });
            });
            video.addEventListener('error', () => {
              video.classList.remove('is-ready');
              this.updateMedia();
            }, { signal });
            ['play', 'pause', 'error'].forEach(name => video.addEventListener(name, () => this.updateButton(), { signal }));
          });
          this.querySelectorAll('.scroll-video-hero__poster').forEach(poster => {
            poster.addEventListener('load', () => this.updateMedia(), { signal });
          });
          this.mobile.addEventListener('change', () => this.rebuild(), { signal });
          this.reduced.addEventListener('change', () => this.rebuild(), { signal });
          this.layoutObserver = new ResizeObserver(() => this.scheduleResize());
          this.layoutObserver.observe(this);
          window.addEventListener('resize', () => this.scheduleResize(), { signal });
          document.addEventListener('shopify:section:load', () => this.scheduleResize(), { signal });
          document.addEventListener('shopify:section:unload', () => this.scheduleResize(), { signal });
          document.addEventListener('visibilitychange', () => this.syncVideo(), { signal });
          this.addEventListener('shopify:block:select', event => {
            const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
            if (index < 0 || !this.trigger) return;
            this.editorIndex = index;
            const position = this.trigger.start + (index > 0 ? (this.trigger.end - this.trigger.start) * 0.75 : 0);
            window.scrollTo({ top: Math.max(0, position), behavior: 'instant' });
            this.updateStage(index, true);
          }, { signal });
          this.addEventListener('shopify:block:deselect', () => {
            this.editorIndex = null;
            if (this.trigger) this.updateProgress(this.trigger.progress, true);
          }, { signal });
          this.preloadObserver = new IntersectionObserver(entries => {
            this.nearby = entries[0].isIntersecting;
            if (this.nearby && this.classList.contains('is-enhanced')) this.prepareVideos();
          }, { rootMargin: '400px' });
          this.preloadObserver.observe(this);
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.syncVideo();
          });
          this.visibilityObserver.observe(this.viewport);
          this.rebuild();
          document.fonts?.ready.then(() => {
            if (!signal.aborted) this.rebuild();
          });
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
        else this.startFrame = requestAnimationFrame(start);
      }

      rebuildIfResized() {
        if (this.sizeKey !== this.geometry().key) this.rebuild();
      }

      scheduleResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.rebuildIfResized(), 180);
      }

      geometry() {
        const header = [...document.querySelectorAll('.header-easy-section, store-header[data-is-sticky="true"]')]
          .filter(element => element.getBoundingClientRect().height > 0)
          .sort((a, b) => Number(b.matches('.header-easy-section')) - Number(a.matches('.header-easy-section')))[0];
        if (this.header !== header) {
          if (this.header) this.layoutObserver.unobserve(this.header);
          this.header = header;
          if (header) this.layoutObserver.observe(header);
        }
        const headerHeight = header ? header.getBoundingClientRect().height + (parseFloat(getComputedStyle(header).top) || 0) : 0;
        const screenHeight = this.measure.clientHeight;
        const width = this.viewport.clientWidth;
        return {
          headerHeight,
          width,
          available: Math.max(0, screenHeight - headerHeight),
          key: `${this.clientWidth}:${width}:${screenHeight}:${headerHeight}`
        };
      }

      rebuild() {
        this.destroyAnimation();
        const geometry = this.geometry();
        this.sizeKey = geometry.key;
        if (!this.panels.length) return;
        const limit = geometry.available;
        if (limit <= 0) return;
        const sizes = this.panels.map(panel => {
          const style = getComputedStyle(panel);
          const ratio = Number(this.mobile.matches ? panel.dataset.mobileRatio : panel.dataset.desktopRatio) || 16 / 9;
          const naturalHeight = geometry.width / ratio;
          const contentHeight = panel.querySelector('.scroll-video-hero__copy').scrollHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          return { naturalHeight, contentHeight };
        });
        const minimumHeight = parseFloat(getComputedStyle(this).getPropertyValue('--svh-min-height')) || 600;
        const preferredHeight = this.mobile.matches ? geometry.width * 15 / 11 : Math.max(geometry.width / 2.4, minimumHeight);
        // Screen space wins over the minimum; editable text can expand the static fallback.
        const height = Math.floor(Math.min(limit, Math.max(preferredHeight, ...sizes.map(size => size.contentHeight))));
        this.panels.forEach((panel, index) => {
          panel.style.setProperty('--svh-static-height', `${Math.max(height, sizes[index].contentHeight)}px`);
        });
        if (!window.gsap || !window.ScrollTrigger || this.reduced.matches) return;
        if (sizes.some(size => size.contentHeight > limit)) return;
        this.headerHeight = geometry.headerHeight;
        this.style.setProperty('--svh-height', `${height}px`);
        this.panels.forEach((panel, index) => {
          panel.style.setProperty('--svh-panel-height', `${height}px`);
          panel.classList.toggle('is-cropped', Math.abs(sizes[index].naturalHeight - height) > 1);
        });
        this.classList.add('is-enhanced');
        gsap.registerPlugin(ScrollTrigger);
        this.context = gsap.context(() => {
          this.copies = this.panels.map(panel => panel.querySelector('.scroll-video-hero__copy'));
          gsap.set(this.copies, { y: 0, autoAlpha: 0 });
          gsap.set(this.helpers.filter(Boolean), { autoAlpha: 0 });
          gsap.set(this.mediaLayers, { autoAlpha: 0, zIndex: 1 });
          this.trigger = ScrollTrigger.create({
            trigger: this,
            start: () => `top ${this.headerHeight}px`,
            end: () => `+=${this.panels.length > 1 ? (this.mobile.matches ? 140 : 200) : 1}`,
            pin: this.panels.length > 1 ? this.viewport : false,
            pinSpacing: true,
            onUpdate: trigger => this.updateProgress(trigger.progress),
            onRefresh: trigger => this.updateProgress(trigger.progress, true)
          });
        }, this);
        this.trigger.refresh();
        this.updateProgress(this.trigger.progress, true);
      }

      updateProgress(progress, immediate = false) {
        const index = this.editorIndex ?? (progress >= 0.5 ? Math.min(1, this.panels.length - 1) : 0);
        this.updateStage(index, immediate);
      }

      updateStage(index, immediate = false) {
        if (index === this.activeIndex && !immediate) return;
        const previous = this.activeIndex;
        const direction = index > previous ? 1 : -1;
        this.transition?.kill();
        this.transition = null;
        const otherCopies = this.copies.filter((copy, panelIndex) => panelIndex !== index);
        const otherHelpers = this.helpers.filter((helper, panelIndex) => helper && panelIndex !== index);
        if (immediate || previous < 0) {
          gsap.set(this.copies, { y: 0, autoAlpha: 0 });
          gsap.set(this.copies[index], { autoAlpha: 1 });
          gsap.set(this.helpers.filter(Boolean), { autoAlpha: 0 });
          if (this.helpers[index]) gsap.set(this.helpers[index], { autoAlpha: 1 });
        } else {
          if (Number(gsap.getProperty(this.copies[index], 'opacity')) === 0) {
            gsap.set(this.copies[index], { y: direction * 50 });
          }
          this.transition = gsap.timeline({ defaults: { duration: 0.3 } })
            .to(otherCopies, { y: -direction * 50, autoAlpha: 0, ease: 'power1.out' }, 0)
            .to(this.copies[index], { y: 0, autoAlpha: 1, ease: 'power1.in' }, 0);
          if (otherHelpers.length) this.transition.to(otherHelpers, { autoAlpha: 0 }, 0);
          if (this.helpers[index]) this.transition.to(this.helpers[index], { autoAlpha: 1 }, 0);
        }
        this.activeIndex = index;
        this.panels.forEach((panel, panelIndex) => panel.setAttribute('aria-hidden', String(panelIndex !== index)));
        this.syncVideo();
        this.updateMedia(immediate || previous < 0);
      }

      updateMedia(immediate = false) {
        if (!this.classList.contains('is-enhanced') || this.activeIndex < 0) return;
        const index = this.activeIndex;
        if (!immediate && (this.mediaTransition || index === this.mediaIndex)) return;
        const video = this.videos[index];
        const poster = this.mediaLayers[index].querySelector('img');
        if (!immediate && video && !video.error && video.readyState < 2) return;
        if (!immediate && (!video || video.error) && poster && !(poster.complete && poster.naturalWidth)) return;
        if (immediate || this.mediaIndex < 0) {
          this.mediaTransition?.kill();
          this.mediaTransition = null;
          gsap.set(this.mediaLayers, { autoAlpha: 0, zIndex: 1 });
          gsap.set(this.mediaLayers[index], { autoAlpha: 1 });
          this.mediaIndex = index;
          this.mediaTarget = -1;
          this.syncVideo();
          return;
        }
        this.mediaTarget = index;
        gsap.set(this.mediaLayers[index], { autoAlpha: 0, zIndex: 2 });
        this.mediaTransition = gsap.to(this.mediaLayers[index], {
          autoAlpha: 1,
          duration: 0.5,
          ease: 'power1.out',
          onComplete: () => {
            this.mediaLayers.forEach((layer, layerIndex) => gsap.set(layer, { autoAlpha: layerIndex === index ? 1 : 0, zIndex: 1 }));
            this.mediaIndex = index;
            this.mediaTarget = -1;
            this.mediaTransition = null;
            this.syncVideo();
            this.updateMedia();
          }
        });
        this.syncVideo();
      }

      prepareVideos() {
        [...new Set([this.activeIndex, this.activeIndex + 1, this.mediaIndex, this.mediaTarget])].forEach(index => {
          const poster = this.mediaLayers[index]?.querySelector('img');
          if (poster) poster.loading = 'eager';
          const video = this.videos[index];
          if (!video) return;
          const src = this.mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
          if (video.getAttribute('src') === src) {
            if (video.readyState >= 2) video.classList.add('is-ready');
            return;
          }
          video.classList.remove('is-ready');
          video.preload = 'auto';
          video.src = src;
          video.load();
        });
      }

      syncVideo() {
        if (!this.videos) return;
        const enhanced = this.classList.contains('is-enhanced');
        if (enhanced && (this.nearby || this.visible)) this.prepareVideos();
        this.videos.forEach((video, index) => {
          if (!video) return;
          const shouldPlay = enhanced && this.visible && !document.hidden && !this.userPaused &&
            (index === this.activeIndex || index === this.mediaIndex || index === this.mediaTarget);
          if (shouldPlay) {
            video.muted = true;
            video.play()?.catch(() => this.updateButton());
          } else video.pause();
        });
        this.updateButton();
      }

      updateButton() {
        const video = this.videos?.[this.activeIndex];
        this.button.hidden = !this.classList.contains('is-enhanced') || !video;
        const paused = this.userPaused || !video || video.paused;
        this.button.classList.toggle('is-paused', paused);
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      }

      destroyAnimation() {
        this.transition?.kill();
        this.mediaTransition?.kill();
        this.mediaTransition = null;
        this.mediaIndex = -1;
        this.mediaTarget = -1;
        this.transition = null;
        this.context?.revert();
        this.context = null;
        this.trigger = null;
        this.activeIndex = -1;
        this.classList.remove('is-enhanced');
        this.style.removeProperty('--svh-height');
        this.panels?.forEach(panel => {
          panel.removeAttribute('aria-hidden');
          panel.style.removeProperty('--svh-panel-height');
          panel.style.removeProperty('--svh-static-height');
          panel.classList.remove('is-cropped');
        });
        this.videos?.forEach(video => {
          if (!video) return;
          video.pause();
          video.classList.remove('is-ready');
        });
        if (this.button) this.button.hidden = true;
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = null;
        this.started = false;
        cancelAnimationFrame(this.startFrame);
        clearTimeout(this.resizeTimer);
        this.preloadObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.layoutObserver?.disconnect();
        this.header = null;
        this.destroyAnimation();
      }
    }
    customElements.define('scroll-video-hero', ScrollVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-water-monitor"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smart-water-monitor')) {
    customElements.define(
      'smart-water-monitor',
      class extends HTMLElement {
        connectedCallback() {
          this.start = this.start || this.init.bind(this);
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.start, { once: true });
          } else {
            this.init();
          }
        }

        init() {
          if (!this.isConnected || this.controller) return;
          this.controller = new AbortController();
          const { signal } = this.controller;
          const rows = Array.from(this.querySelectorAll('[data-swm-reveal]'));
          const revealAll = () => {
            this.revealMedia?.revert();
            this.revealMedia = null;
            rows.forEach((element) => element.classList.add('is-visible'));
            this.classList.remove('is-animated');
          };
          if (this.dataset.designMode === 'true' || !window.gsap || !window.ScrollTrigger) {
            revealAll();
            return;
          }
          gsap.registerPlugin(ScrollTrigger);
          this.revealMedia = gsap.matchMedia();
          this.revealMedia.add(
            {
              motion: '(prefers-reduced-motion: no-preference)',
              reduce: '(prefers-reduced-motion: reduce)',
            },
            (context) => {
              const { reduce } = context.conditions;
              this.classList.toggle('is-animated', !reduce);
              rows.forEach((element) => {
                if (reduce || element.getBoundingClientRect().bottom <= 0) element.classList.add('is-visible');
                if (element.classList.contains('is-visible')) return;
                gsap.fromTo(
                  element,
                  { opacity: 0, y: 24 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: this.closest('.lp365-page') ? 1.8 : 1.2,
                    ease: 'power2.out',
                    clearProps: 'opacity,transform',
                    onStart: () => element.classList.add('is-visible'),
                    scrollTrigger: { trigger: element, start: 'top 90%', once: true },
                  }
                );
              });
            },
            this
          );
          this.addEventListener('focusin', revealAll, { signal });
          document.fonts?.ready.then(() => {
            if (this.isConnected && this.revealMedia) ScrollTrigger.refresh();
          });
        }

        disconnectedCallback() {
          document.removeEventListener('DOMContentLoaded', this.start);
          this.controller?.abort();
          this.controller = null;
          this.revealMedia?.revert();
          this.revealMedia = null;
          this.classList.remove('is-animated');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-route"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('travel-route-map')) {
    class TravelRouteMap extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.initialize();
      }

      disconnectedCallback() {
        this.teardown();
        this.initialized = false;
      }

      initialize() {
        this.route = [
          'China',
          'Kazakhstan',
          'Russia',
          'Georgia',
          'Turkey',
          'Paris',
          'Spain',
          'Portugal',
          'Morocco',
          'Dakar',
          'Africa',
        ];

        this.map = this.querySelector('.travel-route-section__map');
        this.marker = this.querySelector('.current-marker');
        this.motionSegments = Array.from(this.querySelectorAll('.motion-segment'));
        this.maskSegments = Array.from(this.querySelectorAll('.mask-segment'));
        this.cityElements = new Map(
          Array.from(this.querySelectorAll('.city-state')).map((element) => [element.dataset.city, element])
        );
        this.pinMasks = new Map(
          Array.from(this.querySelectorAll('[data-pin-mask]')).map((element) => [element.dataset.pinMask, element])
        );

        if (
          !this.map ||
          !this.marker ||
          this.motionSegments.length === 0 ||
          this.motionSegments.length !== this.maskSegments.length
        ) {
          return;
        }

        const routePair = (this.dataset.routeSegment || '').split('|');
        const progress = this.validateProgress({
          from: routePair[0],
          to: routePair[1],
          progress: this.clamp(Number(this.dataset.progress) / 100),
        });

        this.options = {
          duration: Math.max(0, Number(this.dataset.duration) || 0),
          triggerThreshold: this.clamp(Number(this.dataset.triggerThreshold) / 100),
          progress: progress,
        };

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.started = false;
        this.resizeTimer = null;
        this.animationFrame = null;
        this.handleResize = this.onResize.bind(this);

        this.segmentData = this.motionSegments.map((path, index) => {
          const length = path.getTotalLength();
          const maskPath = this.maskSegments[index];
          maskPath.style.strokeDasharray = length + ' ' + length;
          maskPath.style.strokeDashoffset = String(length);
          return { path: path, maskPath: maskPath, length: length, start: 0, end: 0 };
        });

        let cumulative = 0;
        this.segmentData.forEach((segment) => {
          segment.start = cumulative;
          cumulative += segment.length;
          segment.end = cumulative;
        });

        const targetSegmentIndex = this.route.indexOf(progress.from);
        this.targetDistance =
          this.segmentData[targetSegmentIndex].start + this.segmentData[targetSegmentIndex].length * progress.progress;

        this.resetCityStates();
        this.marker.classList.remove('is-visible');
        this.renderDistance(0);
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.installObserver();
      }

      teardown() {
        if (this.observer) this.observer.disconnect();
        if (this.handleResize) window.removeEventListener('resize', this.handleResize);
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
        this.observer = null;
        this.resizeTimer = null;
        this.animationFrame = null;
      }

      clamp(value) {
        if (!Number.isFinite(value)) return 0;
        return Math.min(1, Math.max(0, value));
      }

      validateProgress(input) {
        const fromIndex = this.route.indexOf(input.from);
        const toIndex = this.route.indexOf(input.to);
        if (fromIndex < 0 || toIndex !== fromIndex + 1) {
          return { from: 'China', to: 'Kazakhstan', progress: 0 };
        }
        return input;
      }

      setCityActive(city) {
        const cityElement = this.cityElements.get(city);
        const pinMask = this.pinMasks.get(city);
        if (cityElement) cityElement.classList.add('is-active');
        if (pinMask) pinMask.setAttribute('opacity', '1');
      }

      resetCityStates() {
        this.cityElements.forEach((element) => element.classList.remove('is-active'));
        this.pinMasks.forEach((element) => element.setAttribute('opacity', '0'));
      }

      getPointAtTravelDistance(distance) {
        const safeDistance = Math.max(0, Math.min(this.targetDistance, distance));
        let segmentIndex = this.segmentData.findIndex((segment) => safeDistance <= segment.end + 0.001);
        if (segmentIndex < 0) segmentIndex = this.segmentData.length - 1;
        const segment = this.segmentData[segmentIndex];
        const localDistance = Math.max(0, Math.min(segment.length, safeDistance - segment.start));
        const point = segment.path.getPointAtLength(localDistance);
        return { x: point.x, y: point.y };
      }

      renderDistance(distance) {
        const safeDistance = Math.max(0, Math.min(this.targetDistance, distance));

        this.segmentData.forEach((segment) => {
          const localDistance = Math.max(0, Math.min(segment.length, safeDistance - segment.start));
          segment.maskPath.style.strokeDashoffset = String(segment.length - localDistance);
        });

        this.setCityActive('China');
        this.segmentData.forEach((segment, index) => {
          if (safeDistance >= segment.end - 0.05) {
            this.setCityActive(this.route[index + 1]);
          }
        });

        const point = this.getPointAtTravelDistance(safeDistance);
        this.marker.setAttribute('transform', 'translate(' + point.x + ' ' + point.y + ')');
      }

      startAnimation() {
        if (this.started) return;
        this.started = true;
        if (this.observer) this.observer.disconnect();
        if (this.handleResize) window.removeEventListener('resize', this.handleResize);

        this.resetCityStates();
        this.marker.classList.add('is-visible');
        this.renderDistance(0);

        if (this.reduceMotion || this.targetDistance <= 0 || this.options.duration <= 0) {
          this.renderDistance(this.targetDistance);
          return;
        }

        const startTime = performance.now();
        const duration = Math.max(1, this.options.duration);

        const frame = (now) => {
          const progress = Math.min(1, (now - startTime) / duration);
          this.renderDistance(this.targetDistance * progress);
          if (progress < 1) {
            this.animationFrame = window.requestAnimationFrame(frame);
          } else {
            this.animationFrame = null;
          }
        };

        this.animationFrame = window.requestAnimationFrame(frame);
      }

      getSafeThreshold() {
        const rect = this.map.getBoundingClientRect();
        const maximumVisibleRatio = Math.min(1, window.innerHeight / Math.max(1, rect.height));
        return Math.min(this.options.triggerThreshold, Math.max(0.05, maximumVisibleRatio * 0.95));
      }

      installObserver() {
        if (this.started) return;
        if (this.observer) this.observer.disconnect();

        if (!('IntersectionObserver' in window)) {
          this.startAnimation();
          return;
        }

        const threshold = this.getSafeThreshold();
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting && entry.intersectionRatio + 0.001 >= threshold) {
                this.startAnimation();
                break;
              }
            }
          },
          { threshold: [threshold] }
        );
        this.observer.observe(this.map);
      }

      onResize() {
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.installObserver(), 120);
      }
    }

    customElements.define('travel-route-map', TravelRouteMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-leak-risk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('water-leak-risk')) {
    customElements.define(
      'water-leak-risk',
      class extends HTMLElement {
        connectedCallback() {
          this.start = this.start || this.init.bind(this);
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.start, { once: true });
          } else {
            this.init();
          }
        }

        init() {
          if (!this.isConnected || this.controller) return;
          this.controller = new AbortController();
          this.revealed = this.revealed || new WeakSet();
          const { signal } = this.controller;
          const rows = Array.from(
            this.querySelectorAll('.water-leak-risk__intro, .water-leak-risk__media, .water-leak-risk__card')
          );
          const revealAll = () => {
            this.revealMedia?.revert();
            this.revealMedia = null;
            rows.forEach((element) => this.revealed.add(element));
          };
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          if (this.dataset.designMode === 'true' || !gsap || !ScrollTrigger) {
            revealAll();
            return;
          }

          gsap.registerPlugin(ScrollTrigger);
          const media = this.querySelector('.water-leak-risk__media');
          this.revealMedia = gsap.matchMedia();
          this.revealMedia.add(
            {
              desktop: '(min-width: 768.01px)',
              mobile: '(max-width: 768px)',
              reduce: '(prefers-reduced-motion: reduce)',
            },
            (context) => {
              const { mobile, reduce } = context.conditions;
              rows.forEach((element) => {
                if (reduce || element.getBoundingClientRect().bottom <= 0) this.revealed.add(element);
                if (this.revealed.has(element)) return;
                const isCard = element.classList.contains('water-leak-risk__card');
                const followMedia = isCard && !mobile && media;
                gsap.fromTo(
                  element,
                  { autoAlpha: 0, y: mobile ? 40 : element === media ? 56 : 48 },
                  {
                    autoAlpha: 1,
                    y: 0,
                    duration: 1.5,
                    delay: followMedia ? 0.25 : 0,
                    ease: 'power2.out',
                    clearProps: 'opacity,visibility,transform',
                    onStart: () => this.revealed.add(element),
                    scrollTrigger: {
                      trigger: followMedia ? media : element,
                      start: 'top 85%',
                      once: true,
                    },
                  }
                );
              });
            },
            this
          );

          const refresh = () => {
            if (this.isConnected && this.revealMedia) ScrollTrigger.refresh();
          };
          this.addEventListener('focusin', revealAll, { signal });
          this.addEventListener('load', refresh, { capture: true, signal });
          document.fonts?.ready.then(refresh);
        }

        disconnectedCallback() {
          document.removeEventListener('DOMContentLoaded', this.start);
          this.controller?.abort();
          this.controller = null;
          this.revealMedia?.revert();
          this.revealMedia = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
